module.exports = __webpack_public_path__ + "static/img/sggs_img_1.677608de.png";